

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";
import { clientGET } from 'Core/data/RestApi';
import { deleteAlerts, AlertsUpdateSystemAlert } from 'Redux/actions'

const INIT_STATE = {
	open: false,
	loading: false,
	result: null,
	error: null,
	unitId: null,
	unit: null,
	loadingEntityLists: false,
	entityLists: [],
	loadingDecodeVin: false,
	deviceVin: null,
	loadingAssetSubtypes: false,
	assetSubtypes: [],
};

const route = "modules/fleet/components/ModalUpdateUnit/redux/slice";

export const fleetModalUpdateUnit = createAsyncThunk("fleet/fleetModalUpdateUnit/updateUnit", async (payload, { rejectWithValue, dispatch }) => {
	try {
		const { unit, inputs, outputs, systemAlerts, systemAlertsToDelete } = payload;
		const {
			id, label, type, hid, esn, imei, driverId, unitVersionId, deviceCategory, locationId,
			useEcuOdometer, offsetEngineOdometer, offsetEcuEngineOdometer, useEcuEngineHours, offsetEngineHours,
			offsetEcuEngineHours, useEcuSpeed, timeZoneId, useEcuVin, mpgHighway, mpgCity, licensePlate, notes,
			offsetEngineOdometerUpdatedOn, offsetEcuEngineOdometerUpdatedOn, offsetEngineHoursUpdatedOn,
			offsetEcuEngineHoursUpdatedOn, vehicleInformation, vehicleStatusId,
			lowBattery, noGps, noGpsTimes, noGpsDays, consistentSpeed, tagIds, alertContacts, defaultDriverId,
			obd2alerts, vbus,
			jbus,
			asset
		} = unit;

		const response = await clientMutation(
			`
				mutation updateUnit (
					$id: Int!, 
					$label: String, 
					$type: String, 
					$hid: String, 
					$esn: String, 
					$imei: String, 
					$driverId: Int, 
					$unitVersionId: Int, 
					$deviceCategory: enumDeviceCategory, 
					$locationId: Int, 
					$useEcuOdometer: Boolean!, 
					$offsetEngineOdometer: Float, 
					$offsetEcuEngineOdometer: Float, 
					$useEcuEngineHours: Boolean!, 
					$offsetEngineHours: Float, 
					$offsetEcuEngineHours: Float, 
					$useEcuSpeed: Boolean!, 
					$timeZoneId: Int, 
					$useEcuVin: Boolean!, 
					$notes: String, 
					$offsetEngineOdometerUpdatedOn: AWSDateTime, 
					$offsetEcuEngineOdometerUpdatedOn: AWSDateTime, 
					$offsetEngineHoursUpdatedOn: AWSDateTime, 
					$offsetEcuEngineHoursUpdatedOn: AWSDateTime, 
					$vehicleInformation: VehicleInformationInput,
					$vehicleStatusId: Int,
					$consistentSpeed: Int
					$consistentDuration: Int
					$lowBattery: Int
					$noGps: Int
					$noGpsTimes: Int
					$noGpsDays: Int 
					$tagIds: [Int]
					$alertContacts: [Int]
					$driverTransitionFrom: String
					$defaultDriverId: Int,
					$asset: AssetInput,
				) {
					updateUnit (
						id: $id, 
						label: $label, 
						type: $type, 
						hid: $hid, 
						esn: $esn, 
						imei: $imei, 
						driverId: $driverId, 
						unitVersionId: $unitVersionId, 
						deviceCategory: $deviceCategory, 
						locationId: $locationId, 
						useEcuOdometer: $useEcuOdometer, 
						offsetEngineOdometer: $offsetEngineOdometer, 
						offsetEcuEngineOdometer: $offsetEcuEngineOdometer, 
						useEcuEngineHours: $useEcuEngineHours, 
						offsetEngineHours: $offsetEngineHours, 
						offsetEcuEngineHours: $offsetEcuEngineHours, 
						useEcuSpeed: $useEcuSpeed, 
						timeZoneId: $timeZoneId, 
						useEcuVin: $useEcuVin, 
						notes: $notes, 
						offsetEngineOdometerUpdatedOn: $offsetEngineOdometerUpdatedOn, 
						offsetEcuEngineOdometerUpdatedOn: $offsetEcuEngineOdometerUpdatedOn, 
						offsetEngineHoursUpdatedOn: $offsetEngineHoursUpdatedOn, 
						offsetEcuEngineHoursUpdatedOn: $offsetEcuEngineHoursUpdatedOn, 
						vehicleInformation: $vehicleInformation,
						vehicleStatusId: $vehicleStatusId,
						consistentSpeed: $consistentSpeed,
						consistentDuration: $consistentDuration,
						lowBattery: $lowBattery,
						noGps: $noGps,
						noGpsTimes: $noGpsTimes,
						noGpsDays: $noGpsDays, 
						tagIds: $tagIds,
						alertContacts: $alertContacts,
						driverTransitionFrom:$driverTransitionFrom
						defaultDriverId: $defaultDriverId,
						asset: $asset,
					) {
						id
					}
				}
			`,
			{
				id,
				label,
				type,
				hid,
				esn,
				imei,
				driverId,
				unitVersionId,
				deviceCategory,
				locationId,
				useEcuOdometer,
				offsetEngineOdometer,
				offsetEcuEngineOdometer,
				useEcuEngineHours,
				offsetEngineHours,
				offsetEcuEngineHours,
				useEcuSpeed,
				timeZoneId,
				useEcuVin,
				mpgHighway,
				mpgCity,
				licensePlate,
				notes,
				offsetEngineOdometerUpdatedOn,
				offsetEcuEngineOdometerUpdatedOn,
				offsetEngineHoursUpdatedOn,
				offsetEcuEngineHoursUpdatedOn,
				vehicleInformation,
				tagIds,
				vehicleStatusId,
				consistentSpeed: consistentSpeed || 0,
				consistentDuration: consistentSpeed || 0,
				lowBattery: lowBattery ? 1 : 0,
				noGps: noGps ? 1 : 0,
				noGpsTimes: noGpsTimes || 0,
				noGpsDays: noGpsDays || 0,
				alertContacts: alertContacts?.length ? alertContacts : [],
				driverTransitionFrom: "CloudWebSite",
				...(typeof defaultDriverId !== "undefined" ? { defaultDriverId: defaultDriverId } : {}),
				asset: asset
			},
			endpoints.GRAPHQL_GENERAL_V2
		);

		if (response?.updateUnit) {

			for (let input of inputs?.d) {
				await clientMutation(
					` mutation deleteUnitInput ($unitId: Int!, $position: Int!) {
						deleteUnitInput (unitId: $unitId, position: $position)
					}`,
					{
						unitId: input.unitId,
						position: input.position
					},
					endpoints.GRAPHQL_GENERAL
				)
			}

			for (let input of inputs?.c) {
				await clientMutation(
					` mutation createUnitInput ($unitId: Int!, $position: Int!, $labelId: Int!) {
						createUnitInput (unitId: $unitId, position: $position, labelId: $labelId) {
							unitId
						}
					}`,
					{
						unitId: input.unitId,
						position: input.position,
						labelId: input.labelId
					},
					endpoints.GRAPHQL_GENERAL
				)
			}

			for (let input of inputs?.u) {
				await clientMutation(
					` mutation updateUnitInput ($unitId: Int!, $position: Int!, $labelId: Int!) {
						updateUnitInput (unitId: $unitId, position: $position, labelId: $labelId) {
							unitId
						}
					}`,
					{
						unitId: input.unitId,
						position: input.position,
						labelId: input.labelId
					},
					endpoints.GRAPHQL_GENERAL
				)
			}

			for (let output of outputs?.c) {
				await clientMutation(
					` mutation createUnitOutput ($unitId: Int!, $position: Int!, $name: String!, $type: enumOutputType!, $state: enumOutputState!) {
						createUnitOutput (unitId: $unitId, position: $position, name: $name, type: $type, state: $state) {
							unitId
						}
					}`,
					{
						unitId: output.unitId,
						position: output.position,
						name: output.name,
						type: output.type,
						state: output.state
					},
					endpoints.GRAPHQL_GENERAL
				)
			}

			for (let output of outputs?.u) {
				await clientMutation(
					`mutation updateUnitOutput ($unitId: Int!, $position: Int!, $name: String!, $type: enumOutputType!, $state: enumOutputState!) {
						updateUnitOutput (unitId: $unitId, position: $position, name: $name, type: $type, state: $state) {
							unitId
						}
					}`,
					{
						unitId: output.unitId,
						position: output.position,
						name: output.name,
						type: output.type,
						state: output.state
					},
					endpoints.GRAPHQL_GENERAL
				)
			}

			if (systemAlertsToDelete?.length) {
				dispatch(deleteAlerts(systemAlertsToDelete, "", ""));
			}

			for (let systemAlert of systemAlerts) {
				if (systemAlert?.id) {
					dispatch(AlertsUpdateSystemAlert(systemAlert));
				} else {
					dispatch(AlertsCreateSystemAlert(systemAlert))
				}
			}

			return { result: true, error: null }

		} else throw 'could not update unit'

	} catch (exc) {
		ExceptionManager(exc, route, "updateUnit");
		return rejectWithValue(exc);
	}
});

export const fleetModalGetUnit = createAsyncThunk("fleet/fleetModalUpdateUnit/getUnit", async (payload, { rejectWithValue }) => {
	try {
		const { id } = payload || {};
		const response = await clientQuery(
			`
                query {
					data: getUnit (id: ${id}) {
						id
						label
						type
						hid
						esn
						imei
						driverId
						driverName
						defaultDriverId
						unitVersionId
						deviceCategory
						deviceModel {
							id
							name
							manufacturer {
								id
								name
							}
						}
						driver {
							id
							title
						}
						defaultDriver {
							id
							title
						}
						tags {
							id
							label
							color
							parentId
							path
							hasChildren
						}
						unitVersion {
							odometerEnable
							unitVersionDriverBehavior
							manufacturerId
							supportedInputs
							supportedOutputs
							tow
							obd2alerts
							ttu
							motion
							hoursEnable
						}
						lastReading {
							accountId
							deviceId
							unitId
							unitType
							deviceLabel
							driverId
							driverName
							make
							model
							vin
							year
							deviceNote
							unitTime
							serverTime
							LastMessageTime
							eventCode
							eventName
							heading
							latitude
							longitude
							address {
								address
								city
								formatted
								state
								zip
							}
							distance
							speed
							speedLimit
							speedLimitRequest
							engineHours
							engineOdometer
							satelliteCount
							datacenter
							messageSource
							region
							republish
							rowId
							sequenceNumber
							unitDiagnostic
							starterSupported
							starterDisabled
							temperatures
							landmark_id
							lm
							landmarkEntered
							landmarkgroup_id
							landmarkname
							landmarkExited
							jobsite_id
							jobsiteEntered
							jobsiteExited
							jobsitename
							dtc
							desiredStarterState
							desiredStarterUpdated 
							ecuEngineHours
							ecuEngineOdometer
							ecuVin
							ecuSpeed
						}
						locationId
						location {
							id
							title
							active
						}
						useEcuOdometer
						offsetEngineOdometer
						offsetEcuEngineOdometer
						useEcuEngineHours
						offsetEngineHours
						offsetEcuEngineHours
						useEcuSpeed
						
						timeZone {
							id
							name
						}
						useEcuVin
						inputs {
							unitId
							position
							labelId
							onLabel
							offLabel
						}
						notes
						offsetEngineOdometerUpdatedOn
						offsetEcuEngineOdometerUpdatedOn
						offsetEngineHoursUpdatedOn
						offsetEcuEngineHoursUpdatedOn
						outputs {
							unitId
							position
							name
							type
							state
						}
						vehicleInformation {
							vin
							make
							model
							year
							engine
							mpgHighway
							mpgCity
							licensePlate
						}
						alertContacts {
							id
							title
							address
							type
						}
						calampSettings {
							towAlert
							lowBattery
							noGps
							noGpsTimes
							noGpsDays
							rapidAcceleration
							hardBrake
							suddenStop
							hardTurn
							motionAlert
							consistentDuration
							consistentSpeed
						}
						vehicleStatusId
						vbus
						jbus
						driverBehavior
						asset {
							id
							label
							assetTypeId
							assetType {
								entityId
								label
							}
							assetSubtypeId
							assetSubtype {
								id
								name
							}
							vin
							make
							model
							year
							engine
							mpgHighway
							mpgCity
							licensePlate
							registrationState
							registrationCountry
							registrationExpiration
							inspectionDeviceType
							inspectionTagId
							powerUnitNumber
							externalId
							isActive
						}
					}
				}
            `,
			{
				id: payload?.id
			},
			endpoints.GRAPHQL_GENERAL_V2
		);

		return {
			...response?.data,
			driverBehaviorAlert: response?.driverBehavior,
			towAlert: response?.unitVersion?.tow,
			motionAlert: response?.unitVersion?.motion,
			consistentSpeedAlert: response?.calampSettings?.consistentSpeed
		}

	} catch (exc) {
		ExceptionManager(exc, route, "getUnit");
		return rejectWithValue(exc);
	}
});

export const fleetModalSearchEntityLists = createAsyncThunk(
	"workOrders/asset/createEditAsset/searchEntityLists",
	async ({ limit = 1000, offset = 0 }, { rejectWithValue }) => {
		try {
			const response = await clientQuery(
				`
					query ($conditions: [EntityListSearchInput], $sort: [EntityListSortInput], $limit: Int, $offset: Int) {
						data: searchEntityLists(
							conditions: $conditions
							sort: $sort
							limit: $limit
							offset: $offset
						) {
							total
							items {
								entityId
								entityName
								parentId
								label
								value1
								value2
							}
						}
					}
				`,
				{
					conditions: [{
						fields: ["entityName"],
						terms: ["AssetType", "InspectionDeviceType", "COUNTRY", "STATE"]
					}],
					sort: {
						field: "entityName",
						order: "ASC"
					},
					limit,
					offset,
				},
				endpoints.GRAPHQL_GENERAL_V2
			);

			return response?.data || { items: [], total: 0 };
		} catch (exc) {
			ExceptionManager(exc, route, "searchEntityLists");
			return rejectWithValue(exc);
		}
	}
);

export const fleetModalSearchAssetSubtypes = createAsyncThunk(
	"fleet/fleetModalUpdateUnit/searchAssetSubtypes",
	async ({ limit = 1000, offset = 0 }, { rejectWithValue }) => {
		try {
			const response = await clientQuery(
				`
					query ($conditions: [AssetSubtypeSearchInput], $sort: [AssetSubtypeSortInput], $limit: Int, $offset: Int) {
						data: searchAssetSubtypes(
							conditions: $conditions
							sort: $sort
							limit: $limit
							offset: $offset
						) {
							total
							items {
								id
								name
							}
						}
					}
				`,
				{
					conditions: [],
					sort: {
						field: "name",
						order: "ASC"
					},
					limit,
					offset,
				},
				endpoints.GRAPHQL_GENERAL_V2
			);

			return response?.data || { items: [], total: 0 };
		} catch (exc) {
			ExceptionManager(exc, route, "searchAssetSubtypes");
			return rejectWithValue(exc);
		}
	}
);


export const fleetModalDecodeVin = createAsyncThunk("fleet/fleetModalUpdateUnit/decodeVin",
	async (payload, { rejectWithValue }) => {
		try {
			const { vin } = payload;
			const url = `${endpoints.NHTSA_URL}/api/vehicles/decodevinvaluesextended/${vin}?format=json`;

			const result = await clientGET('', {}, url, false);

			let vehicleInformation = result?.Results?.[0] || {};

			if (vehicleInformation.ErrorCode !== "0") {
				vehicleInformation = { error: true };
			}

			return vehicleInformation;

		} catch (exc) {
			ExceptionManager(exc, route, "decodeVin");
			return rejectWithValue(exc);
		}
	}
);


const fleetModalUpdateUnitRedux = createSlice({
	name: "fleet/fleetModalUpdateUnit",
	initialState: INIT_STATE,
	reducers: {
		reset(state, action) {
			return action.payload
				? { ...state, ...action.payload }
				: { ...INIT_STATE };
		},
		openModalFleetUpdateUnit(state, action) {
			state.open = true;
			state.unitId = action?.payload?.unitId
		},
	},
	extraReducers: (builder) => {
		builder.addCase(resetALL, () => INIT_STATE);

		//fleetModalUpdateUnit
		builder.addCase(fleetModalUpdateUnit.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(fleetModalUpdateUnit.fulfilled, (state, action) => {
			state.loading = false;
			state.result = action.payload;
		});
		builder.addCase(fleetModalUpdateUnit.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});

		//fleetModalGetUnit
		builder.addCase(fleetModalGetUnit.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(fleetModalGetUnit.fulfilled, (state, action) => {
			state.loading = false;
			state.unit = action.payload;
		});
		builder.addCase(fleetModalGetUnit.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});

		//fleetModalSearchEntityLists
		builder.addCase(fleetModalSearchEntityLists.pending, (state) => {
			state.loadingEntityLists = true;
		});
		builder.addCase(fleetModalSearchEntityLists.fulfilled, (state, action) => {
			state.loadingEntityLists = false;
			state.entityLists = action.payload.items;
		});
		builder.addCase(fleetModalSearchEntityLists.rejected, (state, action) => {
			state.loadingEntityLists = false;
			state.error = action.payload;
		});

		//fleetModalDecodeVin
		builder.addCase(fleetModalDecodeVin.pending, (state) => {
			state.loadingDecodeVin = true;
		});
		builder.addCase(fleetModalDecodeVin.fulfilled, (state, action) => {
			state.loadingDecodeVin = false;
			state.deviceVin = action.payload;
		});
		builder.addCase(fleetModalDecodeVin.rejected, (state, action) => {
			state.loadingDecodeVin = false;
			state.error = action.payload;
		});

		//fleetModalSearchAssetSubtypes
		builder.addCase(fleetModalSearchAssetSubtypes.pending, (state) => {
			state.loadingAssetSubtypes = true;
		});
		builder.addCase(fleetModalSearchAssetSubtypes.fulfilled, (state, action) => {
			state.loadingAssetSubtypes = false;
			state.assetSubtypes = action.payload.items;
		});
		builder.addCase(fleetModalSearchAssetSubtypes.rejected, (state, action) => {
			state.loadingAssetSubtypes = false;
			state.error = action.payload;
		});

	},
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = fleetModalUpdateUnitRedux;

// Extract and export each action creator by name
export const { reset, openModalFleetUpdateUnit } = actions;

// Export the reducer, either as a default or named export
export default reducer;